import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchLicenseData } from "../redux/licenseSlice";
import { Button, Form, Alert, Spinner, Container, Row, Col } from "react-bootstrap";

const Dashboard = () => {
  const [licenseKey, setLicenseKey] = useState("");
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const { data, loading, error: apiError } = useSelector((state) => state.license);
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!licenseKey.trim()) {
      setError("Please enter a valid license key");
      return;
    }
    setError("");
    dispatch(fetchLicenseData(licenseKey));
  };

  return (
    <Container className="mt-5">
      <Row className="justify-content-md-center">
        <Col md={6}>
          <h3 className="text-center mb-4">Enter License Key</h3>

          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>License Key</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter your license key"
                value={licenseKey}
                onChange={(e) => setLicenseKey(e.target.value)}
              />
            </Form.Group>

            {error && <Alert variant="danger">{error}</Alert>}

            <Button type="submit" variant="primary" className="w-100" disabled={loading}>
              {loading ? <Spinner animation="border" size="sm" /> : "Submit"}
            </Button>
          </Form>

          {/* API Error */}
          {apiError && <Alert className="mt-3" variant="danger">{apiError}</Alert>}

          {/* API Response */}
          {data && (
            <div className="mt-4 p-3 border rounded bg-light">
              <h5>License Details</h5>
              <p><strong>Message:</strong> {data.message}</p>
              <p><strong>Count:</strong> {data.count}</p>
              <p><strong>Expire (days):</strong> {data.expire}</p>
              <p><strong>Status:</strong> {data.activation_status ? "Active" : "Inactive"}</p>
              <p><strong>Product:</strong> {data.ProductTitle}</p>
              <p><strong>Activated:</strong> {data.Activated ? "Yes" : "No"}</p>
            </div>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default Dashboard;